// Error monitoring for both the frontend (uncaught exceptions, unhandled promise
// rejections — captured automatically by Sentry's browser SDK) and the backend
// (Supabase/Postgres). Supabase client calls return `{ data, error }` rather than
// throwing, so backend failures don't reach Sentry's automatic handlers — call
// reportError() explicitly at any call site where `error` comes back non-null.
//
// No-ops entirely until VITE_SENTRY_DSN is set, so it's safe to ship before that's
// configured.

import * as Sentry from '@sentry/browser';

let enabled = false;

export function initMonitoring() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  });
  enabled = true;
}

export function reportError(error, context) {
  if (!enabled) return;
  const err = error instanceof Error ? error : new Error(error?.message || String(error));
  Sentry.captureException(err, context ? { extra: context } : undefined);
}
